import {Injectable} from '@angular/core';
import {AbstractControl, ValidatorFn, ValidationErrors} from '@angular/forms';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class CustomValidatorsService {

    constructor() {
    }

    dateFormatValidator(dateFormat: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            const isValid = moment(control.value, dateFormat, true).isValid();
            return !isValid ? {'dateFormat': {value: control.value}} : null;
        };
    }

    futureDate(dateFormat: string): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            const date = moment(control.value, dateFormat, true);
            if (date.isValid()) {
                return date <= moment() ? {'futureDate': {value: control.value}} : null;
            }
            return null;
        };
    }

    lessThan100Validator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            const num = Number(control.value);
            if (num) {
                return control.value > 100 ? {'lessThan100': {value: control.value}} : null;
            }
            return null;
        };
    }

    numberBetweenValidator(min: number, max: number): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            const num = Number(control.value);
            if (num) {
                return control.value < min || control.value > max ? {'numberBetween': {value: control.value}} : null;
            }
            return null;
        };
    }

    irsNotionalValidator(): ValidatorFn {
        return (control: AbstractControl): { [key: string]: any } => {
            const notional1 = control.parent.value.leg1IrsNotional;
            const notional2 = control.parent.value.leg2IrsNotional;
            if ((notional1 !== null) && (notional2 != null)) {
                return (Number(notional1)*Number(notional2) >= 0 )  ? { 'irsWorkaround': {value: control.value}} : null;
            }
            return null;
        };
    }

    atLeastOneInstrument(control: AbstractControl): ValidationErrors | null {
        const instruments = control.get('instruments');
        if (!instruments) {
            return { 'atLeastOneInstrument': true };
        }
        const controls: AbstractControl[] = instruments['controls'];
        if (!controls) {
            return { 'atLeastOneInstrument': true };
        }
        for (const ctrl of controls) {
            const instrTypeCtrl: AbstractControl = ctrl.get('instrType');
            if (instrTypeCtrl.value) {
                return null;
            }
        }
        return { 'atLeastOneInstrument': true };
    }
}
